<template>
  <div class="info-row-section">
    <div class="info-row">
      <!-- Address Box -->
      <dealer-box
        v-if="dealerInfo.address && dealerInfo.address.full"
        :title="$t('dealer.info.address')">
        <p class="store-card__address">
          {{ dealerInfo.address.full }}
        </p>
        <p
          class="store-card__address store-card__address--link"
          @click="handleDirectionsClick">
          {{ $t('dealer.info.directions') }}
        </p>
      </dealer-box>

      <!-- Contacts Box -->
      <dealer-box
        v-if="dealerInfo.contacts && (dealerInfo.contacts.phone || dealerInfo.contacts.whatsapp || dealerInfo.contacts.email || dealerInfo.contacts.website || dealerInfo.contacts.socials)"
        :title="$t('dealer.info.contacts')">
        <div class="store-card__contact">
          <!-- Phone -->
          <div
            v-if="dealerInfo.contacts.phone"
            class="store-card__contact-item">
            <phone-icon class="store-card__icon" />
            <a
              :href="`tel:${dealerInfo.contacts.phone.replace(/\s+/g, '')}`"
              class="store-card__contact-link"
              @click="onContactClick('phone')">
              {{ dealerInfo.contacts.phone }}
            </a>
          </div>

          <!-- Whatsapp -->
          <div
            v-if="dealerInfo.contacts.whatsapp"
            class="store-card__contact-item">
            <whatsapp-icon class="store-card__icon store-card__icon--whatsapp" />
            <a
              :href="buildWaMeUrl(dealerInfo.contacts.whatsapp)"
              target="_blank"
              rel="noopener"
              class="store-card__contact-link"
              @click="onContactClick('whatsapp')">
              {{ dealerInfo.contacts.whatsapp }} <span class="store-card__whatsapp-label">{{ $t('dealer.defaultTexts.whatsappLabel') }}</span>
            </a>
          </div>

          <!-- Email -->
          <div
            v-if="dealerInfo.contacts.email"
            class="store-card__contact-item">
            <email-icon class="store-card__icon" />
            <a
              :href="`mailto:${dealerInfo.contacts.email}`"
              class="store-card__contact-link"
              @click="onContactClick('email')">
              {{ dealerInfo.contacts.email }}
            </a>
          </div>

          <!-- Website -->
          <div
            v-if="dealerInfo.contacts.website"
            class="store-card__contact-item">
            <globe-icon class="store-card__icon" />
            <a
              :href="dealerInfo.contacts.website"
              target="_blank"
              rel="noopener"
              class="store-card__contact-link"
              @click="onContactClick('website')">
              {{ dealerInfo.contacts.website.replace(/^https?:\/\//, '') }}
            </a>
          </div>

          <!-- Social Media -->
          <div
            v-if="dealerInfo.contacts.socials"
            class="store-card__socials">
            <!-- Instagram -->
            <div
              v-if="dealerInfo.contacts.socials.instagram"
              class="store-card__contact-item">
              <!-- <instagram-icon class="store-card__icon" /> -->
              <a
                :href="dealerInfo.contacts.socials.instagram"
                target="_blank"
                rel="noopener"
                class="store-card__contact-link"
                @click="onContactClick('instagram')">
                {{ $t('dealer.info.instagram') }}
              </a>
            </div>

            <!-- Facebook -->
            <div
              v-if="dealerInfo.contacts.socials.facebook"
              class="store-card__contact-item">
              <!-- <facebook-icon class="store-card__icon" /> -->
              <a
                :href="dealerInfo.contacts.socials.facebook"
                target="_blank"
                rel="noopener"
                class="store-card__contact-link"
                @click="onContactClick('facebook')">
                {{ $t('dealer.info.facebook') }}
              </a>
            </div>

            <!-- LinkedIn -->
            <div
              v-if="dealerInfo.contacts.socials.linkedin"
              class="store-card__contact-item">
              <!-- <linkedin-icon class="store-card__icon" /> -->
              <a
                :href="dealerInfo.contacts.socials.linkedin"
                target="_blank"
                rel="noopener"
                class="store-card__contact-link"
                @click="onContactClick('linkedin')">
                {{ $t('dealer.info.linkedin') }}
              </a>
            </div>

            <!-- X (Twitter) -->
            <div
              v-if="dealerInfo.contacts.socials.x"
              class="store-card__contact-item">
              <!-- <x-icon class="store-card__icon" /> -->
              <a
                :href="dealerInfo.contacts.socials.x"
                target="_blank"
                rel="noopener"
                class="store-card__contact-link"
                @click="onContactClick('x')">
                {{ $t('dealer.info.x') }}
              </a>
            </div>

            <!-- YouTube -->
            <div
              v-if="dealerInfo.contacts.socials.youtube"
              class="store-card__contact-item">
              <!-- <youtube-icon class="store-card__icon" /> -->
              <a
                :href="dealerInfo.contacts.socials.youtube"
                target="_blank"
                rel="noopener"
                class="store-card__contact-link"
                @click="onContactClick('youtube')">
                {{ $t('dealer.info.youtube') }}
              </a>
            </div>

            <div
              v-if="dealerInfo.contacts.socials.tiktok"
              class="store-card__contact-item">
              <!-- <tiktok-icon class="store-card__icon" /> -->
              <a
                :href="dealerInfo.contacts.socials.tiktok"
                target="_blank"
                rel="noopener"
                class="store-card__contact-link"
                @click="onContactClick('tiktok')">
                {{ $t('dealer.info.tiktok') }}
              </a>
            </div>

            <div
              v-if="dealerInfo.contacts.socials.pinterest"
              class="store-card__contact-item">
              <!-- <pinterest-icon class="store-card__icon" /> -->
              <a
                :href="dealerInfo.contacts.socials.pinterest"
                target="_blank"
                rel="noopener"
                class="store-card__contact-link"
                @click="onContactClick('pinterest')">
                {{ $t('dealer.info.pinterest') }}
              </a>
            </div>
          </div>
        </div>
      </dealer-box>

      <!-- <pre>
        {{ dealerInfo.hours }}
      </pre> -->
      <!-- Hours Box -->
      <dealer-box
        v-if="dealerInfo.hours"
        :title="$t('dealer.info.hours')">
        <div class="store-card__contact">
          <!-- <div
            v-for="schedule in dealerInfo.hours"
            :key="schedule.day"
            class="store-card__contact-item">
            <span class="store-card__day">{{ schedule.day }}</span>
            <span class="store-card__contact-link">{{ schedule.time }}</span>
          </div> -->

          <div
            class="store-card__contact-item">
            <span
              class="store-card__contact-link"
              v-html="dealerInfo.hours" />
          </div>
        </div>
      </dealer-box>

      <!-- Kitchen Display Box -->
      <dealer-box
        :is-image-box="true"
        class="kitchen-display-box">
        <template #cta>
          <cta
            :text="$t('dealer.info.kitchensOnDisplay')"
            variant="text"
            color="white"
            @click="handleKitchenDisplayClick" />
        </template>
      </dealer-box>
    </div>
  </div>
</template>

<script setup>
  // Import contact icons
  import { buildWaMeUrl } from '~/utils/phone'

  import EmailIcon from '~/assets/svgs/icons/email.svg'
  import GlobeIcon from '~/assets/svgs/icons/globe.svg'
  import PhoneIcon from '~/assets/svgs/icons/phone.svg'
  import WhatsappIcon from '~/assets/svgs/icons/whatsapp.svg'
  import { pushDataLayer } from '~/utils/tracking'

  const props = defineProps({
    dealerInfo: {
      type: Object,
      required: true,
      validator: value => {
        return value.address && value.contacts && value.hours
      }
    }
  })

  const emit = defineEmits([ 'directions-click', 'kitchen-display-click' ])

  const handleDirectionsClick = () => {
    emit('directions-click')
  }

  const handleKitchenDisplayClick = () => {
    emit('kitchen-display-click')
  }

  const onContactClick = type => {
    pushDataLayer({
      name: props.dealerInfo?.storeName,
      shop: `Veneta cucine a ${props.dealerInfo?.city}`,
      provincia: props.dealerInfo?.province,
      tipologia_rivenditore: props.dealerInfo?.isSpecialistSingleBrand ? 'monomarca' : 'plurimarca',
      ...(type == 'phone'
        ? {
          event: 'click_phone_retailer',
          tel: props.dealerInfo?.storePhone
        }
        : {}),
      ...(type == 'email'
        ? {
          event: 'click_email_retailer',
          email: props.dealerInfo?.publicContactEmail
        }
        : {}),
      ...(type == 'whatsapp'
        ? {
          event: 'click_whatsapp_retailer',
          whatsapp: props.dealerInfo?.contacts?.whatsapp
        }
        : {}),
      ...(type == 'maps'
        ? {
          event: 'click_maps_retailer'
        }
        : {}),
      ...(type == 'website'
        ? {
          event: 'click_website_retailer',
          website: props.dealerInfo?.websiteUrl?.url
        }
        : {}),

      ...(type == 'instagram'
        ? {
          event: 'click_instagram_retailer'
        }
        : {}),
      ...(type == 'facebook'
        ? {
          event: 'click_facebook_retailer'
        }
        : {}),
      ...(type == 'linkedin'
        ? {
          event: 'click_linkedin_retailer'
        }
        : {}),
      ...(type == 'x'
        ? {
          event: 'click_x_retailer'
        }
        : {}),
      ...(type == 'youtube'
        ? {
          event: 'click_youtube_retailer'
        }
        : {}),
      ...(type == 'tiktok'
        ? {
          event: 'click_tiktok_retailer'
        }
        : {})

    })
  }
</script>

<style lang="scss" scoped>
  .info-row-section {
    margin-bottom: var(--space-xxl);

    @include up-to-tablet {
      margin-bottom: var(--space-xl);
    }
  }

  .info-row {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto;

    @include mq($until: medium) {
      .kitchen-display-box {
        grid-row: 1;
      }
    }

    @include mq(medium) {
      grid-template-columns: repeat(2, 1fr);
      border-top: 1px solid #e5e5e5;
      border-bottom: 1px solid #e5e5e5;
    }

    @include mq(large) {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  // Copy StoreCard styles for address section
  .store-card__address {
    font-size: var(--typography-size-ui-kit-18);
    color: var(--color-black);
    margin: 0;
    line-height: 160%;
    display: flex;
    align-items: flex-start;
    gap: var(--space-ss);
    font-style: normal;
    font-weight: 400;

    &--link {
      color: var(--color-red);
      cursor: pointer;
      margin-top: var(--space-s);

      &:hover {
        text-decoration: underline;
      }
    }
  }

  // Copy StoreCard styles for contact section
  .store-card__contact {
    display: flex;
    flex-direction: column;
    gap: var(--space-ss);
    height: 100%;
  }

  .store-card__contact-item {
    display: flex;
    align-items: center;
    gap: var(--space-xxs);
    font-size: var(--typography-size-ui-kit-18, 18px);
  }

  .store-card__contact-link {
    color: var(--color-dark-grey);
    text-decoration: none;
    transition: color var(--timing-fast) var(--easing-default);

    &:hover {
      color: var(--color-red);
    }
  }

  .store-card__icon {
    flex-shrink: 0;
    color: var(--color-black);
    width: 20px;
    height: 20px;

    &--whatsapp {
      color: var(--color-black);
    }
  }

  .store-card__whatsapp-label {
    font-size: inherit;
  }

  .store-card__socials {
    display: flex;
    flex-flow: row wrap;
    gap: var(--space-xs-desktop);
    margin-top: auto;
  }

  // Special styling for day labels in hours section
  .store-card__day {
    font-family: var(--font-family-poppins);
    font-size: var(--typography-size-ui-kit-18, 18px);

    // font-weight: var(--font-weight-medium);
    color: var(--color-black);
    min-width: 20px;
    text-align: left;
  }
</style>
